import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const HelpCenter = () => {
  const navigate = useNavigate();

  const handleBackToPortal = () => {
    navigate('/portal');
  };

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          p: 2, 
          borderBottom: '1px solid #eee', 
          background: '#f7faff' 
        }}
      >
        <IconButton 
          edge="start" 
          color="inherit" 
          onClick={handleBackToPortal} 
          aria-label="back to portal" 
          sx={{ mr: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Help Centre
        </Typography>
      </Box>

      {/* Content */}
      <Box sx={{ p: 0, height: '100%', overflowY: 'auto', background: '#fff' }}>
        {/* Empty for now, add content here later */}
        <Box sx={{ p: 3 }}>
          <Typography variant="body1" color="text.secondary">
            Help Centre content will be added here.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HelpCenter; 